import { render, staticRenderFns } from "./IncomeMenu.vue?vue&type=template&id=561d71c4"
import script from "./IncomeMenu.vue?vue&type=script&lang=js"
export * from "./IncomeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports